import { Button, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Party from 'src/assets/congratulation.png';


const Thankyou = (props) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100%' }}>
            <div className='mb-20'>
                <img className='h-80 w-80' src={Party} alt='' />
            </div>
            <div className='mb-20'>
                <Typography variant='h4' className='text-orange-400'>Thank You!</Typography>
            </div>
            <div>
                <Typography variant='h5'>Your Request is successfully submitted! With Request Id :  <stong>{props?.requestId}</stong></Typography>
            </div>
        </div>
    )
}

export default Thankyou